<script setup lang="ts">
import { gestureLayers } from "~/classes/gestures/BaseGesture"

const { currentFilePreview } = useNavigation()
const { navIgnoreMainViewGestures, previewNoFade } = useGlobals()
const { state: gestureState } = useGestures()
const { state: previewState, DWELL_DELAY_MS } = usePreview()

// This is for our dwell timer. We watch the mouse movement and if it doesn't move for
// a certain amount of time, we fade the UI (or rather, we set usePreview()'s isFaded'.
let timeout: any | null = null
const updateIsFaded = () => {
  if (isDefined(timeout))
    clearTimeout(timeout)
  if (previewState.value.isFaded)
    previewState.value.isFaded = false
  timeout = setTimeout(() => {
    if (previewState.value.isFaded || !isDefined(gestureState.value.mousePosition))
      return
    // check if we are over a `previewNoFade` element
    const target = document.elementFromPoint(
      gestureState.value.mousePosition.clientX,
      gestureState.value.mousePosition.clientY,
    )
    if (target && getFirstMatchingParent(target, e => e.classList?.contains(previewNoFade)))
      return
    previewState.value.isFaded = true
  }, DWELL_DELAY_MS)
}
const watcher = watch(() => gestureState.value.mousePosition, updateIsFaded)
onUnmounted(() => {
  if (isDefined(timeout))
    clearTimeout(timeout)
  watcher.stop()
  previewState.value.isFaded = false
})
</script>

<template>
  <div class="preview-container" :class="[navIgnoreMainViewGestures]">
    <preview-file
      v-if="currentFilePreview"
      :file="currentFilePreview.asStatic()"
      :gesture-layer="gestureLayers.mainView"
    />
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.preview-container
  @apply h-full w-full flex items-center justify-center overflow-hidden
</style>
